<template>
    <div class="wzselect" :style="'max-width: ' + wzsettings.max_width + ';'" :id="elID" :class="('theme-' + wzsettings.theme) + (isOpen && ' open')">
        <!-- <select class="wzselect-select">
            <option v-for="opt in optionsComp" :key="opt[this.wzsettings.key]" :value="opt[this.wzsettings.key]" :selected="opt[this.wzsettings.key]==modelValue">{{opt.val}}</option>
        </select> -->
        <input class="wzselect-select" :value="modelValue">
        
        <div :style="'display: inline-block; width:' + wzsettings.width + '; min-width:150px; position:relative;'" v-click-away="away">
            <div class="wzselect-inp inp" type="text" @click="toggleOpen">
                <p >
                    <span v-for="opt_res in resComp" :key="opt_res" v-html="opt_res[this.wzsettings.val]"></span>
                </p>
            </div>
            <div class="wzselect-options" :class="{'open_to_top': openDirection=='top'}" v-if="isOpen" :style="optionsStyle">
                <div v-if="wzsettings.search" class="search">
                    <input type="text" v-model="q" @input="search" placeholder="חיפוש" ref="inp">
                </div>
                <ul>
                    <li v-for="(opt, i) in optionsComp" :key="opt[this.wzsettings.key]" @click="val(opt)">
                        <input type="checkbox" :id="'input-' + i" :checked="res && res.some((item_b) => item_b == opt[settings.key])" >
                        <label v-html="opt[this.wzsettings.val]"></label>
                    </li>
                    <li v-if="optionsComp.length == 0">לא נמצאו תוצאות</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { directive } from "vue3-click-away";
export default {
  directives: {
    ClickAway: directive
  },
  props:["settings", "options", "modelValue"],
  emits: ['update:modelValue', 'change'],
    data(){
        return {
            elID: 'wzselect_' + this.uuid(),
            openDirection: 'bottom',
            openMaxHeight: 300,
            wzsettings: {
                theme: 'dark',
                placeholder: ``,
                label: ``,
                width: 'auto',
                max_width: 'unset',
                search: true,
                url: '', // 'wizzocms/Admins/ac_search'
                val: 'val',
                key: 'key',
                // expload: false

            },
            q: '',
            res: [],
            m_options: this.options,
            isOpen:false
        };
    },
    mounted(){
        console.log(this.modelValue, "g");
        
        if (typeof(this.modelValue) != 'object') {
            this.res = []
        } else {
            this.res = this.modelValue
        }
        for (let i in this.settings)
        {
            this.wzsettings[i] = this.settings[i];
        }

        /*
        for (let i in this.m_options)
        {
            if (this.m_options[i].key == this.value)
            {
                this.val(this.m_options[i]);
            }
        }*/
    },
    methods:{
        away: function() { 
        this.isOpen = false;
        },
        val(opt){ 
            //this.value = opt;
            // this.isOpen = false;
            
            let res = this.res
            let isDelete = false;
            for (let i = 0; i < res.length; i++) {
                console.log(+opt[this.wzsettings.key]);
                if (+opt[this.wzsettings.key] === +res[i]) {
                    res.splice(i, 1)
                    isDelete = true;
                }
            }
            if (!isDelete) {
                res.push(opt[this.wzsettings.key])
            }
            this.res = res;

            // if(opt[this.wzsettings.expload]) {
            //     res = `|${res.join('||')}|`
            // }
            console.log("ddddddddddd", this.res);
            this.$emit('update:modelValue', this.res);
            this.$emit('change', this.res);

            this.q='';
        },
        toggleOpen(){
            this.isOpen=!this.isOpen;
            //let parent = this.getScrollParent(document.querySelector('#' + this.elID));

            if (this.isOpen)
            {
                if (this.wzsettings.search && !this.is_mobile())
                {
                    setTimeout(() => {
                        this.$refs.inp.focus();
                    }, 50);
                }

                this.calcOptionsSize();

                //parent.addEventListener('scroll', this.calcOptionsSize, true);
            }
            else
            {
                //parent.removeEventListener('scroll', this.calcOptionsSize, true);
            }
        }, 

        calcOptionsSize(){
            let parent = this.getScrollParent(document.querySelector('#' + this.elID));

            const parentPos = parent.getBoundingClientRect();
            const childPos  = document.querySelector('#' + this.elID).getBoundingClientRect();
            const relativePos = {};

            relativePos.top    = childPos.top - parentPos.top,
            relativePos.right  = childPos.right - parentPos.right,
            relativePos.bottom = childPos.bottom - parentPos.bottom,
            relativePos.left   = childPos.left - parentPos.left;

            const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
             var viewportOffset = document.querySelector('#' + this.elID).getBoundingClientRect();
            var top = viewportOffset.top; // relativePos.top;
            // console.log(top)
            if (vh/2 < top) 
            {
                this.openDirection = 'top';
                this.openMaxHeight = (viewportOffset.top < top ? viewportOffset.top : top) - 100;
            }
            else
            {
                this.openDirection = 'bottom';
                this.openMaxHeight = (viewportOffset.top < vh-top ? vh-viewportOffset.top : vh-top) - 100;
            }

            //alert(this.openMaxHeight)
        },

        getScrollParent(node=null) {
            if (node == null) return document.querySelector('body');

            if (node.scrollHeight > node.clientHeight) 
            {
                return node;
            } 
            else 
            {
                return this.getScrollParent(node.parentNode);
            }
        },

        search(){
            if (this.wzsettings.url != '')
            {
                fetch(this.wzsettings.url, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ q: this.q})

                    
                }).then(res => res.json())
                .then((res) => {
                    this.m_options = res;
                });
            }

        },
            
        uuid() {
            return Math.random().toString(36).slice(4)
        },
    },
    computed:{
        resComp() {            
            if (this.res) {
                return this.m_options.filter(item => this.res.some((item_b) => item_b == item[this.settings.key]));
            } else {
                return []; // or handle the null case as needed
            }
        },
        optionsStyle(){ 
            return {
                maxHeight: this.openMaxHeight+ 'px'
            }
        },
        valueComp(){
            let lbl = (this.wzsettings.label != '' ? this.wzsettings.label + ': ' : '');

            if (!this.isNull(this.modelValue))
            {
                for (let i in this.m_options)
                {
                    if (this.modelValue == this.m_options[i][this.wzsettings.key]) return lbl + (lbl != '' ? '<b>' + this.m_options[i][this.wzsettings.val] + '</b>' : this.m_options[i][this.wzsettings.val]);
                }
            }   
    
            return lbl + (lbl != '' ? '<b>' + this.wzsettings.placeholder + '</b>' : this.wzsettings.placeholder);
        },
        optionsComp()
        {
            let ret = [];
            
            console.log(this.m_options)

            let findIn = function(str, q) { 
                if (str == undefined) return false;
                return str.toUpperCase().indexOf(q.toUpperCase()) >= 0; };
            
            for (let i in this.m_options)
            {
                if (!this.search || findIn(this.m_options[i][this.wzsettings.val],this.q)) ret.push(this.m_options[i]);
            }
            
            return ret;
        }
    },
}

</script>

<style lang="scss" scoped>
.wzselect{ display: inline; 

    &.theme-light {
        --wz-input-bg: #fff;
        --wz-text-color: #303756;
        --wz-bg-color: #fff;
        --wz-input-height: 36px;
    }
    &.theme-dark {
        --wz-input-bg: var(--loading-color);
        --wz-text-color: #303756;
        --wz-bg-color: #fff;
        --wz-input-height: 36px;
    }
    &.theme-transparent {
        --wz-input-bg: var(--loading-color);
        --wz-text-color: #303756;
        --wz-bg-color: #fff;
        --wz-input-height: 36px;
    }

    &.open {
        .wzselect-inp { border-color: var(--dark_blue); }
    }

    color: var(--wz-text-color);
    .wzselect-select { display: none !important; }
    .wzselect-inp { border: solid 1px var(--border_color); cursor: pointer; background: var(--wz-input-bg); padding: 0 15px; border-radius: 12px; white-space: nowrap; min-height: var(--wz-input-height); position: relative; display: flex; justify-content: space-between; align-items: center; line-height: normal !important; 
        p { display: flex; gap:6px; align-items: center; overflow: hidden; width: 100%;}
        span {}
        &::after { content: ''; background-position: center; background-size: contain; background-repeat: no-repeat;background-image: url('@/assets/arrow-bottom.svg'); width:12px; height: 8px; display: block; font-size: 10px; margin-right: 6px; }

    }
    
    .wzselect-options { position: absolute;  right: 0px; min-width: 100%; background: var(--wz-bg-color); box-shadow: 0px 4px 10px rgba(53, 78, 104, 0.1); border-radius: 12px; z-index: 999999999999; overflow-y: auto; 
        ul { box-shadow: 0px 1px 2px 0px rgba(0, 45, 85, 0.25);
 list-style: none; display: block; padding: 5px; border: 1px solid #E7F0F3;
            li { min-height: 40px; display: flex; align-items: center; flex-direction: row !important; gap:6px; border-radius: 5px; padding: 0 10px; white-space: nowrap; font-size: 15px; cursor: pointer;
                &:hover { background: #eee; color:#333 }
                &.selected { /*background: #eee; color:#333*/ font-weight: bold; }
            }
        }
        --local_gap: 2px;
        &:not(.open_to_top) {  top: calc(100% + var(--local_gap)); }
        &.open_to_top { bottom: calc(100% + var(--local_gap)); }
    }

    .search { background: #eee; position: sticky; top: 0px;
        input { width:100%; border:none; height: 30px; padding: 0 10px; font-size: 15px; background: none;}
    }

    &.theme-dark .wzselect-inp {     border: 1px solid #9e9e9e; }
    &.theme-transparent .wzselect-inp { padding: 0px; }

}
</style>